// Framework-agnostic control-plane calls for the public booking flow.
// Auth is the publishable key (safe in the browser) + Origin/Referer.
export async function fetchEventConfig(base, publishableKey) {
    const url = `${base}/api/founding-agent/public/booking/event?key=${encodeURIComponent(publishableKey)}`;
    const res = await fetch(url);
    if (!res.ok) {
        const body = await res.text().catch(() => "");
        throw new Error(`Failed to load event config (${res.status}): ${body}`);
    }
    return res.json();
}
export async function fetchAvailability(base, publishableKey, from, to, timeZone) {
    const url = `${base}/api/founding-agent/public/booking/availability` +
        `?key=${encodeURIComponent(publishableKey)}` +
        `&from=${encodeURIComponent(from)}` +
        `&to=${encodeURIComponent(to)}` +
        `&timeZone=${encodeURIComponent(timeZone)}`;
    const res = await fetch(url);
    if (!res.ok) {
        const body = await res.text().catch(() => "");
        throw new Error(`Failed to load availability (${res.status}): ${body}`);
    }
    const data = (await res.json());
    return data.slots;
}
export async function postBooking(base, publishableKey, payload) {
    const url = `${base}/api/founding-agent/public/booking?key=${encodeURIComponent(publishableKey)}`;
    const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    if (!res.ok) {
        const body = await res.text().catch(() => "");
        let errorMsg;
        try {
            const parsed = JSON.parse(body);
            errorMsg = parsed.message ?? parsed.error ?? body;
        }
        catch {
            errorMsg = body || `Request failed (${res.status})`;
        }
        throw new Error(errorMsg);
    }
    return res.json();
}
